// extracted by mini-css-extract-plugin
export var searchHeader = "_20-0";
export var searchHeaderDark = "_20-1";